<template>
  <BaseCard>
    <BaseCardHeader>
      <div class="flex justify-between items-baseline -mr-2">
        <div>
          {{ $t('productInfo') | capitalize }}
        </div>
        <RouterLink :to="editRoute" class="btn btn-brand style-link size-sm">
          {{ $t('global.edit') | capitalize }}
        </RouterLink>
      </div>
    </BaseCardHeader>
    <BaseCardBody>
      <div class="-m-6">
        <BaseList nested>
          <BaseListBody>
            <BaseListItem>
              <span class="text-gray-600"> Description </span>
              <div v-if="product.description">
                {{ product.description }}
              </div>
              <div v-else>-</div>
            </BaseListItem>
            <BaseListItem>
              <span class="text-gray-600"> Supplementary description </span>
              <div v-if="product.supplementaryDescription">
                {{ product.supplementaryDescription }}
              </div>
              <div v-else>-</div>
            </BaseListItem>
            <BaseListItem>
              <span class="text-gray-600"> Product URL </span>
              <div v-if="product.url">
                <a :href="product.url" target="blank">{{ product.url }}</a>
              </div>
              <div v-else>-</div>
            </BaseListItem>
            <BaseListItem>
              <span class="text-gray-600 capitalize block mb-1"> Categories </span>
              <ul v-if="categories.length" class="flex -mx-1">
                <li v-for="category in categories" :key="category.id" class="uppercase px-1">
                  <BaseBadge orange>
                    {{ category.name }}
                  </BaseBadge>
                </li>
              </ul>
              <span v-else class="text-teal-500">Δεν έχουν οριστεί</span>
            </BaseListItem>
            <BaseListItem>
              <span class="text-gray-600 capitalize block mb-1"> Tags </span>
              <ul v-if="tags.length" class="flex -mx-1">
                <li v-for="tag in tags" :key="tag.id" class="uppercase px-1">
                  <BaseBadge custom :style="tag.customProperties">
                    <span v-if="tag.category">{{ tag.category }}/</span>{{ tag.name }}
                  </BaseBadge>
                </li>
              </ul>
              <span v-else class="text-teal-500">Δεν έχουν οριστεί</span>
            </BaseListItem>
            <BaseListItem>
              <span class="text-gray-600"> Price </span>
              <div>{{ product.price }}</div>
            </BaseListItem>
          </BaseListBody>
        </BaseList>
      </div>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import { entityComputed } from '@/store/helper';

export default {
  name: 'ProductInfo',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...entityComputed,
    categories() {
      return this.product.categories.map((id) => this.entityById('productCategories', id));
    },
    tags() {
      return this.product.tags.map((id) => this.entityById('tags', id));
    },
    editRoute() {
      if (this.product.type === 'basic') {
        return { name: 'admin.products.basicProducts.basicProduct.edit' };
      }
      if (this.product.type === 'package') {
        return { name: 'admin.products.packages.package.edit' };
      }

      if (this.product.type === 'service') {
        return { name: 'admin.products.services.service.edit' };
      }

      return this.$route.path;
    },
  },
};
</script>
